export {
    SuiAccordionModule,
    SuiAccordion,
    SuiAccordionPanel,
    SuiAccordionService
} from "./index";
